import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, Subscription, BehaviorSubject, Observer, Subject } from 'rxjs';

import { EventsListPlayerService } from './events-list-player.service';
import { Router } from '@angular/router';
import { AppNavigationService } from './app-navigation.service';

import { environment } from '../../../environments/environment';

import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { webSocket } from 'rxjs/webSocket';

// ----------------------------------------------------
/*

    RxJS Subjects are both an Observable and an Observer. Using these Subjects we can concurrently listen to and send messages to a single websocket, this essentially opens up two way communication and allows us to do cool things such as build chat systems.

    The Websocket service will handle direct communication with the socket and the Chat service will expose a simple interface that our other components can easily interact with.

    private defferedPromptSubject = new Subject<any>();
    https://stackoverflow.com/questions/43348463/what-is-the-difference-between-subject-and-behaviorsubject
    https://stackoverflow.com/questions/39494058/behaviorsubject-vs-observable

    // Bring up the score-tracker page directly for testing
    http://localhost:4900/score-tracker/1850?leagueID=1850&matchID=2&gameID=1

    Use behaviorSubject to get messages from the server

*/
// ----------------------------------------------------


@Injectable()
export class WebSocketRxjsService
{
    // Used to Get the Logged In Players ID  
    userTokenInfo;

    // Server URL
    apiUrl = environment.socketApiUrl;    

    // Set Local Storage Variable
    localStorage = window.localStorage;

    // Our socket connection
    private socket: any;

    socketConnectedStatus = {
        connected: false, 
        socketConfigured: false, 
        message: 'Socket has NOT be configured',
        socketID: '-1'
    };      
    

    // TODO: use BehaviorSubject ONLY instead of Observable
    // BehaviorSubject internally by the API to call.next(), only service function has ability to call .next()

    // Holds the current Socket Status 
    public socketStatusSubject$ = new BehaviorSubject<any>({});
    // 
    public newScoresDataSubject$ = new BehaviorSubject<any>({});
    // 
    public scoreTrackerBasicScoresSubject$ = new BehaviorSubject<any>({});
    // 
    public savedMatchScoresBasicFromDeviceSubject$ = new BehaviorSubject<any>({eventID: 0});
    // 
    public savedMatchScoresBasicFromAdminSubject$ = new BehaviorSubject<any>({eventID: 0});
    // 
    public onMatchAssignToCourtSubject$ = new BehaviorSubject<any>({eventID: 0});
    // Used to pass the chart data back to the Match Chart for dynamic updating
    public matchChartDataSubject$ = new BehaviorSubject<any>({});

    // Holds info if the device is used as courtside tablet
    localUniqueDeviceInfo =  null;    

    constructor(
                private authService: AuthService,
                private eventsListPlayerService: EventsListPlayerService,
                private router: Router,
                private appNavigationService: AppNavigationService,
                private snackBar: MatSnackBar,       
    ) 
    {

        // ------------------------------------------------------
        // Check to see if the current device is setup as courtside tablet
        // ------------------------------------------------------
        this.localUniqueDeviceInfo = this.checkDeviceSetup(); 

    }

    // This is used if the device is refreshed while on the scoreTrackerBasic
    // it will need to connect as an admin device with adminID = NN, eventID = 0 and CourtID
    // from localstorage
    // Check to See if this device is setup as a courtside device
    //
    // ----------------------------------------------------
    // Check to See if the Device has been setup previously
    // Stored in local storage
    // ----------------------------------------------------
    checkDeviceSetup()
    {
        this.localUniqueDeviceInfo = this.getLocalStorageDeviceInfo();   
    }    


    public connectToServer(): Observable<any> 
    {
        console.log('this.socket : ', this.socket);
        this.socket = webSocket('ws://localhost:9001?adminid=26&eventid=0');

        return this.socket.subscribe(
        (msg: any) =>
        {
            console.log('message received: ' + msg); // Called whenever there is a message from the server.
        }, 
        (err) =>
        {
            console.log(err); // Called if at any point WebSocket API signals some kind of error.
        },
        () =>
        {
            console.log('complete'); // Called when connection is closed (for whatever reason).
        } 
        );        
    }



    // ---------------------------------------------
    // Get LocalStorage Device Info
    // ---------------------------------------------
    public getLocalStorageDeviceInfo()
    {
        let deviceInfo = this.localStorage.getItem(`socketIOUniqueDeviceInfo`);
        return JSON.parse(deviceInfo);
    }

}
